export const OnRename = 'onRename'

export const OnCompletion = 'onCompletion'

export const OnBraceCompletion = 'onBraceCompletion'

export const OnDefinition = 'onDefinition'

export const OnFormatting = 'onFormatting'

export const OnDiagnostic = 'onDiagnostic'

export const OnFileSystem = 'onFileSystem'

export const OnHover = 'onHover'

export const OnReferences = 'onReferences'

export const OnSemanticTokens = 'onSemanticTokens'

export const OnSourceControl = 'onSourceControl'

export const OnStatusBarItem = 'onStatusBarItem'

export const OnTabCompletion = 'onTabCompletion'

export const OnTextSearch = 'onTextSearch'

export const OnTypeDefinition = 'onTypeDefinition'

export const OnImplementation = 'onImplementation'

export const OnClosingTag = 'onClosingTag'
